import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function TermsOfServicePage() {
  const { t } = useTranslation(["common", "dashboard", "members", "trainers", "reservations", "settings", "payments", "rooms", "messaging", "business", "memberDashboard"]);

  return (
    <div className="min-h-screen bg-slate-50">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-white shadow-sm">
        <div className="container mx-auto px-4 py-4 flex items-center gap-4">
          <Link to="/" className="flex items-center gap-2 text-grey hover:text-navy transition-colors">
            <ArrowLeft className="w-5 h-5" />
            <span>{t('common:back')}</span>
          </Link>
          <h1 className="font-heading font-bold text-lg text-navy">{t("common:termsOfUse")}</h1>
        </div>
      </header>

      <div className="container mx-auto px-4 py-8 max-w-4xl">
        <div className="bg-white rounded-2xl shadow-sm p-6 md:p-10">
          <h1 className="font-heading text-3xl font-bold text-navy mb-2">{t("common:termsOfUse")}</h1>
          <p className="text-grey mb-8">Son güncelleme: Şubat 2026</p>

          <div className="prose prose-slate max-w-none">
            <h2 className="font-heading text-xl font-semibold text-navy mt-8 mb-4">1. Kabul ve Onay</h2>
            <p className="text-grey leading-relaxed mb-4">
              PBStudio platformunu ("Platform") kullanarak bu Kullanım Koşullarını kabul etmiş sayılırsınız. 
              Bu koşulları kabul etmiyorsanız, platformu kullanmayınız.
            </p>

            <h2 className="font-heading text-xl font-semibold text-navy mt-8 mb-4">2. Hizmet Tanımı</h2>
            <p className="text-grey leading-relaxed mb-4">
              PBStudio, spor salonları, pilates stüdyoları ve fitness merkezleri için dijital yönetim platformudur. 
              Hizmetlerimiz şunları içerir:
            </p>
            <ul className="list-disc list-inside text-grey mb-4 space-y-2">
              <li>İşletme profili yönetimi</li>
              <li>Üye kayıt ve takip sistemi</li>
              <li>Rezervasyon ve randevu yönetimi</li>
              <li>Antrenör yönetimi</li>
              <li>Ödeme ve abonelik takibi</li>
              <li>Raporlama ve analitik</li>
            </ul>

            <h2 className="font-heading text-xl font-semibold text-navy mt-8 mb-4">3. Hesap Oluşturma</h2>
            <p className="text-grey leading-relaxed mb-4">
              Platform hizmetlerinden yararlanmak için hesap oluşturmanız gerekmektedir:
            </p>
            <ul className="list-disc list-inside text-grey mb-4 space-y-2">
              <li>Doğru ve güncel bilgiler sağlamalısınız</li>
              <li>Hesap güvenliğinden siz sorumlusunuz</li>
              <li>Hesap bilgilerinizi üçüncü kişilerle paylaşmamalısınız</li>
              <li>18 yaşından büyük olmalısınız</li>
            </ul>

            <h2 className="font-heading text-xl font-semibold text-navy mt-8 mb-4">4. Kullanıcı Yükümlülükleri</h2>
            <p className="text-grey leading-relaxed mb-4">Platform kullanıcıları olarak:</p>
            <ul className="list-disc list-inside text-grey mb-4 space-y-2">
              <li>Yasalara uygun hareket etmelisiniz</li>
              <li>Diğer kullanıcıların haklarına saygı göstermelisiniz</li>
              <li>Yanıltıcı veya sahte bilgi paylaşmamalısınız</li>
              <li>Platformun güvenliğini tehlikeye atacak eylemlerden kaçınmalısınız</li>
              <li>Spam veya istenmeyen içerik paylaşmamalısınız</li>
            </ul>

            <h2 className="font-heading text-xl font-semibold text-navy mt-8 mb-4">5. İşletme Sahipleri İçin</h2>
            <p className="text-grey leading-relaxed mb-4">İşletme hesabı sahipleri ek olarak:</p>
            <ul className="list-disc list-inside text-grey mb-4 space-y-2">
              <li>İşletmenizi temsil etme yetkisine sahip olmalısınız</li>
              <li>Sunduğunuz hizmetlerin doğruluğundan sorumlusunuz</li>
              <li>Üye verilerini koruma yükümlülüğünüz bulunmaktadır</li>
              <li>Abonelik ücretlerini zamanında ödemelisiniz</li>
            </ul>

            <h2 className="font-heading text-xl font-semibold text-navy mt-8 mb-4">6. Ödeme ve Abonelik</h2>
            <p className="text-grey leading-relaxed mb-4">Ücretli hizmetler için:</p>
            <ul className="list-disc list-inside text-grey mb-4 space-y-2">
              <li>Abonelik ücretleri peşin olarak tahsil edilir</li>
              <li>İptal talepleri bir sonraki dönemden itibaren geçerlidir</li>
              <li>Fiyat değişiklikleri önceden bildirilir</li>
              <li>Ödeme bilgileri güvenli şekilde işlenir</li>
            </ul>

            <h2 className="font-heading text-xl font-semibold text-navy mt-8 mb-4">7. Fikri Mülkiyet</h2>
            <p className="text-grey leading-relaxed mb-4">
              Platform üzerindeki tüm içerik, tasarım, logo ve yazılım PBStudio'nun fikri mülkiyetidir. 
              İzinsiz kopyalama, dağıtma veya değiştirme yasaktır.
            </p>

            <h2 className="font-heading text-xl font-semibold text-navy mt-8 mb-4">8. Sorumluluk Sınırlaması</h2>
            <p className="text-grey leading-relaxed mb-4">
              Platform "olduğu gibi" sunulmaktadır. Hizmet kesintileri, veri kaybı veya 
              dolaylı zararlardan dolayı sorumlu tutulamayız. Maksimum sorumluluk, 
              ödenen abonelik ücreti ile sınırlıdır.
            </p>

            <h2 className="font-heading text-xl font-semibold text-navy mt-8 mb-4">9. Hesap Askıya Alma</h2>
            <p className="text-grey leading-relaxed mb-4">
              Kullanım koşullarının ihlali durumunda hesabınız önceden bildirimde bulunulmaksızın 
              askıya alınabilir veya sonlandırılabilir.
            </p>

            <h2 className="font-heading text-xl font-semibold text-navy mt-8 mb-4">10. Değişiklikler</h2>
            <p className="text-grey leading-relaxed mb-4">
              Bu koşulları dilediğimiz zaman güncelleme hakkını saklı tutarız. 
              Önemli değişiklikler en az 30 gün öncesinden bildirilecektir.
            </p>

            <h2 className="font-heading text-xl font-semibold text-navy mt-8 mb-4">11. Uygulanacak Hukuk</h2>
            <p className="text-grey leading-relaxed mb-4">
              Bu koşullar Türkiye Cumhuriyeti kanunlarına tabidir. 
              Uyuşmazlıklar İstanbul mahkemelerinde çözümlenecektir.
            </p>

            <h2 className="font-heading text-xl font-semibold text-navy mt-8 mb-4">12. İletişim</h2>
            <p className="text-grey leading-relaxed mb-4">
              Kullanım koşulları hakkında sorularınız için:
            </p>
            <p className="text-grey mb-4">
              <strong>E-posta:</strong> info@pbstudio.com<br />
              <strong>Adres:</strong> İstanbul, Türkiye
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
